import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UUID } from 'angular2-uuid';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';

import { AuthenticateService } from 'src/app/shared/services/authenticate.service';
import { Groupsservice } from '../../shared/services/groups.service';
import { RepoService } from '../../shared/services/repo.service'
import { FileUploadService } from 'src/app/shared/services/fileupload.service';

@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.sass']
})
export class AddGroupComponent implements OnInit {

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  groupForm: FormGroup;
  groupObj: any = {};
  name: string;
  description: string;
  globalImgUrl: string;
  urls = [];
  imageNameList = [];
  categoryImage: any;
  uploadFileList: any[] = [];
  imageUploadService: string;
  cropUuid: string = '';
  componentData: any;
  selectedCrop: any;
  cropVarietiesArray: any = [];
  loading: boolean;
  groupsArray: any[] = [];
  showList: boolean = true;
  type: string;
  editIndex: any;
  groupId: string;
  btnLoading: boolean = false;
  uploadMultipleFileList = [];

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private groupsservice: Groupsservice,
    private fileUploadService: FileUploadService) { }

  ngOnInit() {
    this.getAllGroups();
    this.groupForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }
  ngDoCheck() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
      console.log("globalImgUrl", this.globalImgUrl)
    }
  }
  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }
  addGroup() {
    this.btnLoading = false;
    this.groupForm.reset();
    this.showList = false;
    this.imageNameList = []; // TO SAVE IMAGE URLS
    this.urls = [];
    this.groupObj = { name: '', description: '' };
    console.log("groupObj ", this.groupObj);
    this.type = 'save';
  }
  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split('/')[0] == 'image') {
          // if (event.target.files[i].type == 'application/pdf') {
          var reader = new FileReader()
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
          }
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService = 'var_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set('file', event.target.files[i], this.imageUploadService);
          formData.append('name', this.imageUploadService);
          this.uploadFileList.push(formData);
          this.uploadMultipleFileList.push(formData);
        }
      }
    }
  }
  // imageInput(event) {
  //   var type = event.target.files[0].type.split('/')[1];
  //   console.log("type", type);
  //   if (event.target.files[0].type == 'application/pdf') {
  //     if (event.target.files && event.target.files[0]) {
  //       var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (event: any) => {
  //         this.urls = event.target.result;
  //       }
  //       let iuuid = UUID.UUID();
  //       this.imageUploadService = iuuid + "." + event.target.files.item(0).type.split('/')[1];
  //       this.imageNameList = event.target.files[0]
  //       console.log("pdf", this.imageNameList)
  //     }
  //   } else {
  //     alert({ icon: 'error', text: "The uploaded file format " + type + " is not supported " });
  //   }
  // }
  //   fileChange(event) {
  //     let fileList: FileList = event.target.files;
  //     if(fileList.length > 0) {
  //         let file: File = fileList[0];
  //         let formData:FormData = new FormData();
  //         formData.append('uploadFile', file, file.name);
  //         let headers = new Headers();
  //         /** In Angular 5, including the header Content-Type can invalidate your request */
  //         headers.append('Content-Type', 'multipart/form-data');
  //         headers.append('Accept', 'application/json');
  //         let options = new RequestOptions({ headers: headers });
  //         this.http.post(`${this.apiEndPoint}`, formData, options)
  //             .map(res => res.json())
  //             .catch(error => Observable.throw(error))
  //             .subscribe(
  //                 data => console.log('success'),
  //                 error => console.log(error)
  //             )
  //     }
  // }
  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
    console.log("deleteImage ", this.imageNameList, event);
  }
  uploadFileToActivity() {
    console.log("@@Came to uploadFileToActivity")
    for (var i = 0; i < this.uploadMultipleFileList.length; i++) {
      this.fileUploadService.uploadMultipleFiles(this.uploadMultipleFileList[i], this.imageUploadService);
    }
  }
  saveData() {
    this.loading = true;
    this.btnLoading = true;
    let obj = {
      groupId: UUID.UUID(),
      name: this.groupObj.name,
      image: this.imageNameList,
      description: this.groupObj.description
    }
    console.log("obj::", obj)
    this.groupsservice.saveECGroups(obj).then((data: any) => {
      console.log("data::", data)
      if (this.imageUploadService) {
        this.uploadFileToActivity();
      }
      this.btnLoading = false;
      if (data) {
        Swal({ title: "Saved successfully" })
        this.showList = true;
        this.groupForm.reset();
        this.imageNameList = [];
        this.urls = [];
        this.uploadFileList = [];
        this.getAllGroups();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
        this.showList = true;
      }
    });
  }

  getAllGroups() {
    this.loading = true;
    this.groupsArray = [];
    this.groupsservice.getAllECGroups({}).then((data: any) => {
      if (data.length > 0) {
        this.groupsArray = data;
        this.loading = false;
        console.log("@@Groups array:", this.groupsArray);
      } else {
        this.loading = false;
      }
    });
  }
  editCancle() {
    this.showList = true;
  }
  cancel() {
    this.showList = true;
    this.groupForm.reset();
    this.imageNameList = [];
    this.urls = [];
  }
  editData(index) {
    this.groupId = '';
    this.showList = false;
    this.imageNameList = [];
    this.urls = [];
    this.editIndex = index;
    console.log("group edited", this.groupsArray[index]);
    this.groupObj = this.groupsArray[index];
    this.groupId = this.groupsArray[index].groupId;
    this.imageNameList = this.groupsArray[index].image;
    for (var i = 0; i < this.groupsArray[index].image.length; i++) {
      console.log("images : ", this.groupsArray[index].image[i])
      this.urls.push(this.globalImgUrl + this.groupsArray[index].image[i]);
      this.uploadFileList.push(this.globalImgUrl + this.groupsArray[index].image[i]);
    }
    this.type = 'update';
  }
  updateData() {
    this.loading = true;
    this.btnLoading = true;
    this.groupObj.image = this.groupObj.image.concat(this.imageNameList.filter((item) => {
      return this.groupObj.image.indexOf(item) < 0;
    }));
    let obj = {
      groupId: this.groupId,
      name: this.groupObj.name,
      image: this.groupObj.image,
      description: this.groupObj.description
    }
    this.groupsservice.updateECGroups(obj, this.groupId).then((data: any) => {
      console.log("@@Image upload service:", this.imageUploadService)
      if (this.imageUploadService) {
        this.uploadFileToActivity();
      }
      this.btnLoading = false;
      if (data.result == "SUCCESS") {
        Swal({ title: "Updated successfully" })
        this.groupForm.reset();
        this.imageNameList = [];
        this.urls = [];
        this.uploadFileList = [];
        this.showList = true;
        this.getAllGroups();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }


}


// https://stackoverflow.com/questions/40214772/file-upload-in-angular
// console.log("pdf:", event.target.files[0], event.target.files[0].type)
// if (event.target.files[i].type == 'application/pdf') {
  // accept="application/pdf"  // this is html code
